"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.Body = exports.Wrapper = void 0;
var core_1 = require("@blueprintjs/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var style_scss_1 = __importDefault(require("./style.scss"));
var Wrapper = function (props) {
    var width = 500;
    if (props.size === 'sm') {
        width = 360;
    }
    else if (props.size === 'md') {
        width = 700;
    }
    else if (props.size === 'lg') {
        width = 900;
    }
    var onSubmit = function (e) {
        e.preventDefault();
        props.onSubmit();
    };
    return (react_1.default.createElement(core_1.Dialog, __assign({ className: style_scss_1.default.dialog, transitionDuration: 0, canOutsideClickClose: false, enforceFocus: false, style: { width: width, height: props.height } }, props), props.onSubmit ? (react_1.default.createElement("form", { className: style_scss_1.default.form, onSubmit: onSubmit }, props.children)) : (props.children)));
};
exports.Wrapper = Wrapper;
var Body = function (_a) {
    var children = _a.children, className = _a.className;
    return react_1.default.createElement("div", { className: (0, classnames_1.default)(core_1.Classes.DIALOG_BODY, core_1.Classes.UI_TEXT, style_scss_1.default.dialogBody, className) }, children);
};
exports.Body = Body;
var Footer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: core_1.Classes.DIALOG_FOOTER },
        react_1.default.createElement("div", { className: core_1.Classes.DIALOG_FOOTER_ACTIONS }, children)));
};
exports.Footer = Footer;
